import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { articlePreviews } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-foreground-900">
              oopbuyspread
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              Der ultimative OOPBuy Spreadsheet Guide für Deutschland, Österreich und die Schweiz. Finde die besten Spreadsheets und Shopping-Tipps.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 mb-3 text-sm uppercase tracking-wide">
              <a href="#kategorien" className="hover:text-primary-500 transition-colors">Kategorien</a>
            </h4>
            <div className="grid grid-cols-2 gap-1.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 mb-3 text-sm uppercase tracking-wide">
              Einkaufsguide
            </h4>
            <div className="flex flex-col gap-1.5">
              {articlePreviews.map((ap) => (
                <Link
                  key={ap.slug}
                  to={`/artikel/${ap.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap truncate"
                >
                  {ap.category} Guide
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 mb-3 text-sm uppercase tracking-wide">
              Links
            </h4>
            <div className="flex flex-col gap-1.5">
              <Link
                to="/"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                Startseite
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                OOPBuy Spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 oopbuyspread.lol – Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              Guide
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              OOPBuy Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}